import { render, staticRenderFns } from "./blok-download-button.vue?vue&type=template&id=521ca1c2&scoped=true&"
import script from "./blok-download-button.vue?vue&type=script&lang=js&"
export * from "./blok-download-button.vue?vue&type=script&lang=js&"
import style0 from "./blok-download-button.vue?vue&type=style&index=0&id=521ca1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521ca1c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('521ca1c2')) {
      api.createRecord('521ca1c2', component.options)
    } else {
      api.reload('521ca1c2', component.options)
    }
    module.hot.accept("./blok-download-button.vue?vue&type=template&id=521ca1c2&scoped=true&", function () {
      api.rerender('521ca1c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/blok-download-button.vue"
export default component.exports